import { render, staticRenderFns } from "./MostPlayed.vue?vue&type=template&id=aed65cc8&"
import script from "./MostPlayed.vue?vue&type=script&lang=js&"
export * from "./MostPlayed.vue?vue&type=script&lang=js&"
import style0 from "./MostPlayed.vue?vue&type=style&index=0&id=aed65cc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports